<ng-container *ngIf="gdprConfig$ | async as gdprConfig">
    <div class="gdpr" *ngIf="showGDPR" [@fadeInOnEnter] [@fadeOutOnLeave]>
        <div class="container">
            <div class="row gdpr-content">
                <div
                    class="col-11"
                    [innerHtml]="gdprConfig.title_html | trustContent"
                ></div>
                <div class="col-1">
                    <serviceos-ng-system-icon
                        [icon]="'close-cancel'"
                        (click)="hide()"
                    ></serviceos-ng-system-icon>
                </div>
            </div>
        </div>
    </div>
</ng-container>
